import { BaseModel } from './BaseModel';
import { Ration } from './Ration';

export class Silo extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.id = data.id ?? null;
    this.identification = data.identification ?? null;

    this.availableWeight = isApi ? data.feedmetrics?.available_weight : data.availableWeight ?? null;

    this.freeWeight = isApi ? data.feedmetrics?.free_weight : data.freeWeight ?? null;

    this.status = isApi ? data.feedmetrics?.status : data.status ?? null;
    const lastReceived = isApi ? data.feedmetrics?.last_received_time : data.lastReceivedTime;

    this.lastReceivedTime = lastReceived ? new Date(lastReceived) : null;

    this.currentRation = isApi ? data.feedmetrics?.current_ration : data.currentRation;

    const rationsData = isApi ? data.feedmetrics?.rations : data.rations;

    this.rations = Array.isArray(rationsData)
      ? rationsData.map((r) => Ration.create(r, source))
      : [];

    this.lastDelivery = isApi
      ? Ration.create(data.feedmetrics?.last_delivery || data.lastDelivery, source)
      : null;

    this.avgConsumption = isApi ? data.feedmetrics?.consumption_mean : data.avgConsumption ?? null;

    this.birdAvgConsumption = isApi
      ? data.feedmetrics?.bird_consumption_mean
      : data.birdAvgConsumption ?? null;

    this.invoiceDeliveries = isApi
      ? data.feedmetrics?.invoice_deliveries
      : data.invoiceDeliveries ?? null;
    this.totalOccupation = isApi ? data.feedmetrics?.total_occupation : data.totalOccupation ?? null;

    this.occupationHistory = data.occupation_history || data.occupationHistory || [];
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}
